import styled from "styled-components";

export const Header2 = styled.h2`
  padding: 15px 0 10px 20px;
  margin: 0;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
  text-decoration: underline;
`;
